{
  "id": "instalcorp",
  "name": "Instalcorp",
  "font": {
    "family": {
      "body": "\"Segoe UI Variable Text\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", Roboto, Arial, sans-serif",
      "display": "\"Segoe UI Variable Display\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", Roboto, Arial, sans-serif",
      "mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
    },
    "size": {
      "2xs": "11px",
      "xs": "12px",
      "sm": "13px",
      "base": "14px",
      "md": "15px",
      "lg": "17px",
      "xl": "20px",
      "2xl": "26px"
    },
    "weight": {
      "normal": "400",
      "medium": "500",
      "semibold": "600",
      "bold": "700"
    },
    "leading": {
      "tight": "1.25",
      "normal": "1.4",
      "relaxed": "1.6"
    }
  },
  "space": {
    "0": "0px",
    "px": "1px",
    "0.5": "2px",
    "1": "4px",
    "1.5": "6px",
    "2": "8px",
    "2.5": "10px",
    "3": "12px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "8": "32px",
    "10": "40px",
    "12": "48px"
  },
  "radius": {
    "none": "0px",
    "xs": "4px",
    "sm": "6px",
    "md": "10px",
    "lg": "14px",
    "xl": "18px",
    "full": "9999px"
  },
  "border": {
    "width": "1px",
    "strong": "2px"
  },
  "control": {
    "height": "36px",
    "heightSm": "30px",
    "padX": "14px"
  },
  "colors": {
    "light": {
      "bg": "#eef0f3",
      "surface": "#ffffff",
      "surface-2": "#f7f8fa",
      "ink": "#1b1f24",
      "ink-2": "#444c56",
      "muted": "#747d88",
      "line": "#dde1e6",
      "line-2": "#eceef1",
      "accent": "#b35d27",
      "accent-ink": "#8c4518",
      "accent-soft": "#f8ebe1",
      "today": "#fcf4ee",
      "grey-cell": "#e3e6ea",
      "warn": "#b87900",
      "warn-soft": "#fdf3dc",
      "warn-ink": "#6e4a00",
      "act": "#1d5bc9",
      "act-soft": "#e4edfb",
      "ok": "#11805b",
      "ok-soft": "#e3f4ec",
      "off": "#8d97a2",
      "off-soft": "#eef0f2",
      "bad": "#c0352d",
      "bad-soft": "#fbe7e5"
    },
    "dark": {
      "bg": "#111418",
      "surface": "#1b1f24",
      "surface-2": "#22272e",
      "ink": "#e8ebee",
      "ink-2": "#c3c9d0",
      "muted": "#8f98a3",
      "line": "#343b44",
      "line-2": "#2a3038",
      "accent": "#d9844e",
      "accent-ink": "#f0b48c",
      "accent-soft": "#3a2a20",
      "today": "#2a221c",
      "grey-cell": "#2c323a",
      "warn": "#e0a83a",
      "warn-soft": "#3a2e12",
      "warn-ink": "#f2cf7c",
      "act": "#7aa5f0",
      "act-soft": "#1d2a40",
      "ok": "#4fc196",
      "ok-soft": "#173328",
      "off": "#8f98a3",
      "off-soft": "#2a3038",
      "bad": "#ef7d74",
      "bad-soft": "#3d2120"
    }
  },
  "shadow": {
    "light": {
      "sm": "0 1px 2px rgba(20, 26, 34, 0.05)",
      "md": "0 1px 2px rgba(20, 26, 34, 0.05), 0 6px 18px rgba(20, 26, 34, 0.06)"
    },
    "dark": {
      "sm": "0 1px 2px rgba(0, 0, 0, 0.4)",
      "md": "0 1px 2px rgba(0, 0, 0, 0.4), 0 4px 14px rgba(0, 0, 0, 0.3)"
    }
  },
  "sections": {
    "service": {
      "light": {
        "accent": "#d9a300",
        "accent-ink": "#5a4300",
        "accent-soft": "#fff4cc",
        "today": "#fffaeb"
      },
      "dark": {
        "accent": "#f2b705",
        "accent-ink": "#f7d46b",
        "accent-soft": "#3a3115",
        "today": "#2a2615"
      }
    }
  }
}
